import React, { createContext } from 'react';

export interface SelectionData {
  parentKey: string;
  selectedGroupIds: {
    [groupKey: string]: {
      [optionKey: string]: boolean;
    };
  };
}

interface SelectContextProps {
  setSelectionData: React.Dispatch<React.SetStateAction<SelectionData>>;
  selectionData: SelectionData;
}

const ROOT_PARENT_ID = 'ROOT_PARENT_ID';

const defaultSelectionData = {
  parentKey: ROOT_PARENT_ID,
  selectedGroupIds: {
    [ROOT_PARENT_ID]: {},
  },
};

const SelectContext = createContext<SelectContextProps>({
  setSelectionData: () => {},
  selectionData: defaultSelectionData,
});

export { SelectContext as default, ROOT_PARENT_ID, defaultSelectionData };
